import { useEffect, useState } from 'react';
/**
 * `true` once `window.scrollY` exceeds `threshold`, `false` otherwise — toggles both ways as the
 * page scrolls past and back below the threshold. Starts `false` on the server and syncs to the
 * real scroll position on mount, so a browser-restored scroll offset (reload, back-navigation) is
 * caught immediately rather than waiting for the next scroll event.
 */
export const useScrollThreshold = (threshold) => {
    const [isPastThreshold, setIsPastThreshold] = useState(false);
    useEffect(() => {
        let frameId = null;
        const sync = () => setIsPastThreshold(window.scrollY > threshold);
        const handleScroll = () => {
            if (frameId != null) {
                return;
            }
            frameId = requestAnimationFrame(() => {
                frameId = null;
                sync();
            });
        };
        sync();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (frameId != null) {
                cancelAnimationFrame(frameId);
            }
        };
    }, [threshold]);
    return isPastThreshold;
};
